export default function kobleAdditionalInfo() {
    const controls = document.querySelectorAll('.property-single__additional--controls button');
    const tabs = document.querySelectorAll('.property-single__additional--wrapper .container > div');

    if (!controls.length || !tabs.length) return;

    function initTabs() {
        // Calculate the maximum height of all tabs
        const maxHeight = Array.from(tabs).reduce((max, tab) => {
            return Math.max(max, tab.offsetHeight);
        }, 0);

        // Apply the maximum height to all tabs
        tabs.forEach(tab => {
            tab.style.height = `${maxHeight}px`;
        });

        // Set default visibility: hide all tabs except the first one
        tabs.forEach((tab, index) => {
            if (index === 0) {
                tab.classList.remove('d-none');
            } else {
                tab.classList.add('d-none');
            }
        });

        // Set default active button
        controls.forEach((button, index) => {
            if (index === 0) {
                button.classList.add('active');
            } else {
                button.classList.remove('active');
            }
        });
    }

    function resetTabs() {
        // Show all tabs and reset height
        tabs.forEach(tab => {
            tab.style.height = '';
            tab.classList.remove('d-none');
        });
    }

    function handleResize() {
        if (window.innerWidth >= 768) {
            initTabs();
        } else {
            resetTabs();
        }
    }

    // Initial check
    handleResize();

    // Listen for resize
    window.addEventListener('resize', handleResize);

    controls.forEach(button => {
        button.addEventListener('click', () => {
            if (window.innerWidth < 768) return; // Disable click on mobile

            const targetClass = button.dataset.container;

            // Hide all tabs
            tabs.forEach(tab => {
                tab.classList.add('d-none');
            });

            // Show the target tab
            const targetTab = document.querySelector(`.${targetClass}`);
            if (targetTab) {
                targetTab.classList.remove('d-none');
            }

            // Update active button state
            controls.forEach(btn => {
                btn.classList.remove('active');
            });
            button.classList.add('active');
        });
    });
}
